import React, { useState } from "react";
import AppConfig from "../../constants/AppConfig";
import {
  Divider,
  IconButton,
  ListItemIcon,
  makeStyles,
  Menu,
  MenuItem,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { Icon } from "@iconify/react/dist/iconify.js";

const StyledMenu = withStyles({
  paper: {
    elevation: 0, // Note: elevation must be passed via props, not style
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    marginTop: 12, // mt: 1.5 (1.5 * 8 = 12px in MUI spacing system)
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      marginLeft: -4,
      marginRight: 8,
    },
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      backgroundColor: "#fff", // or theme.palette.background.paper
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
})(Menu);

export default function Avatar({ profile_picture, props }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { user } = props;

  return (
    <div>
      <Tooltip
        title={window.sys_app_translate("Account settings", props.user.lang)}
      >
        <div className="header-user">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <img
              className="profile-picture"
              src={require("../../assets/default-profile-picture.png")}
              alt="Avatar"
            />
            <div className="name">{props.user.name}</div>
          </IconButton>
        </div>
      </Tooltip>

      <StyledMenu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "center", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        elevation={0}
        PaperProps={{
          style: {
            marginTop: 55, // Move down more
            marginLeft: 75, // Move right
            // You can also use transform for fine tuning
            // transform: 'translate(10px, 20px)'
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            props.history.push("/app/users/profile");
          }}
        >
          <Icon
            icon="carbon:user-avatar-filled"
            width="30"
            height="30"
            color={AppConfig.themeColors.primary}
            className="me-3"
          />
          <span style={{ fontSize: "1.25rem" }}>
            {window.sys_app_translate("Profile", props.user.lang)}
          </span>
        </MenuItem>
        <Divider style={{ color: "red" }} />

        <MenuItem
          onClick={() => {
            handleClose();
            props.setLoading(true);
            props.logoutUser();
          }}
        >
          <Icon
            icon="material-symbols:logout-rounded"
            width="30"
            height="30"
            color={AppConfig.themeColors.primary}
            className="me-3"
          />
          <span style={{ fontSize: "1.25rem" }}>
            {window.sys_app_translate("Logout", props.user.lang)}
          </span>
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
